import { render, staticRenderFns } from "./ChatroomIndex.vue?vue&type=template&id=0af50760&scoped=true&"
import script from "./ChatroomIndex.vue?vue&type=script&lang=js&"
export * from "./ChatroomIndex.vue?vue&type=script&lang=js&"
import style0 from "./ChatroomIndex.vue?vue&type=style&index=0&id=0af50760&lang=scss&scoped=true&"
import style1 from "./ChatroomIndex.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af50760",
  null
  
)

export default component.exports